export interface AccessItem {
  [key: string]: boolean;
}

export interface ProfileItem {
  title: string
  items: AccessItem
}

export const profilesAccess: ProfileItem[] = [
  {
    title: "BASIC",
    items: {
      "Controller state": true,
      "Alarm management": true,
      "Scheduler": true,
      "Task creation": true,
      "Activator control": false,
      "Feature control": false,
      "Light control": false,
      "Pump control": false,
      "Chemical control": false,
      "Sensor control": false,
      "Controller settings modification": false,
      "Reports": false,
      "Custom Sequence": false,
    }
  },
  {
    title: "PREMIUM",
    items: {
      "Controller state": true,
      "Alarm management": true,
      "Scheduler": true,
      "Task creation": true,
      "Activator control": true,
      "Feature control": true,
      "Light control": true,
      "Pump control": true,
      "Chemical control": true,
      "Sensor control": true,
      "Controller settings modification": true,
      "Reports": true,
      "Custom Sequence": true,
    }
  },
]



// WEBPACK FOOTER //
// ./src/app/access/constants.ts